import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuantityUnit } from '../enums/quantity-unit';
import { QuantityUnitPipe } from '../pipes/quantity-unit.pipe';

@Component({
  selector: 'app-quantity-unit',
  imports: [CommonModule, QuantityUnitPipe],
  templateUrl: './quantity-unit.component.html',
  styleUrl: './quantity-unit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityUnitComponent {
  public readonly unit = input.required<QuantityUnit>();
}
